var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAttachmentLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "e/icon/file/attachment_line"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.7103 17.5653C20.37 15.9056 20.37 13.2146 18.7103 11.5549L12.1696 5.01412C11.7791 4.62359 11.7791 3.99043 12.1696 3.5999C12.5601 3.20938 13.1933 3.20938 13.5838 3.5999L20.1245 10.1407C22.5653 12.5815 22.5653 16.5387 20.1245 18.9795C17.6838 21.4203 13.7265 21.4203 11.2857 18.9795L3.33175 11.0256C1.57382 9.26763 1.57382 6.41746 3.33175 4.65953C5.08968 2.9016 7.93985 2.9016 9.69778 4.65953L17.6507 12.6124C18.7252 13.687 18.7252 15.4291 17.6507 16.5036C16.5762 17.5781 14.834 17.5781 13.7595 16.5036L6.51269 9.25676C6.12217 8.86623 6.12217 8.23307 6.51269 7.84254C6.90322 7.45202 7.53638 7.45202 7.92691 7.84254L15.1737 15.0894C15.4672 15.3829 15.943 15.3829 16.2365 15.0894C16.5299 14.7959 16.5299 14.3201 16.2365 14.0267L8.28357 6.07374C7.30668 5.09686 5.72284 5.09686 4.74596 6.07374C3.76908 7.05062 3.76908 8.63446 4.74596 9.61135L12.6999 17.5653C14.3596 19.225 17.0506 19.225 18.7103 17.5653Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachmentLine);
export default __webpack_public_path__ + "static/media/attachment_line.3bd11ded9ff75c37b3af3a7cc331e6a7.svg";
export { ForwardRef as ReactComponent };